import {
  DashedLine02Icon,
  FolderExportIcon,
  Home09Icon,
  HelpSquareIcon,
} from "hugeicons-react";
import { useState, useEffect, useRef } from "react";
import "./Menu.css";

function Menu({
  onSelectToolChange,
  setCurrFileToApp,
  goHome,
  pageNumber,
  setPageNumber,
}) {
  const [activeButton, setActiveButton] = useState("select");
  const [showTooltips, setShowTooltips] = useState(false);
  const fileInputRef = useRef(null);

  useEffect(() => {
    onSelectToolChange(activeButton === "select");
    if (activeButton !== "help") {
      setShowTooltips(false);
    }
  }, [activeButton, onSelectToolChange]);

  const handleButtonClick = (buttonName) => {
    if (activeButton === buttonName) {
      setActiveButton("");
    } else {
      setActiveButton(buttonName);
    }
  };

  const handleHelpClick = () => {
    handleButtonClick("help");
    setShowTooltips(!showTooltips);
  };

  const handleFolderClick = () => {
    handleButtonClick("folder");
    fileInputRef.current.click();
  };

  const handleHomeClick = () => {
    handleButtonClick("home");
    goHome("home");
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setCurrFileToApp(file);
      // Do something with the selected file, e.g., display its name
      //console.log("Selected PDF:", file.name);
    }
    setPageNumber(1);
  };

  return (
    <div className={`menu-container ${showTooltips ? "show-tooltips" : ""}`}>
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        accept=".pdf"
        onChange={handleFileChange}
      />
      <div className="top-buttons">
        <div
          className={`selection-container ${
            activeButton === "select" ? "active" : ""
          }`}
          onClick={() => handleButtonClick("select")}
        >
          <DashedLine02Icon size={35} color={"#000000"} variant={"stroke"} />
          <div className="tooltip">Selection Tool</div>
        </div>
      </div>
      <div className="bottom-buttons">
        <div
          className={`selection-container ${
            activeButton === "folder" ? "active" : ""
          }`}
          onClick={() => handleFolderClick("folder")}
        >
          <FolderExportIcon size={35} color={"#000000"} variant={"stroke"} />
          <div className="tooltip">Change PDF</div>
        </div>
        <div
          className={`selection-container ${
            activeButton === "help" ? "active" : ""
          }`}
          onClick={() => handleHelpClick()}
        >
          <HelpSquareIcon size={35} color={"#000000"} variant={"stroke"} />
          <div className="tooltip">Help</div>
        </div>
        <div
          className={`selection-container ${
            activeButton === "home" ? "active" : ""
          }`}
          onClick={() => handleHomeClick("home")}
        >
          <Home09Icon size={35} color={"#000000"} variant={"stroke"} />
          <div className="tooltip">Home</div>
        </div>
      </div>
    </div>
  );
}

export default Menu;
